export class Constants {
  static RECOVERY_SUCCESS_MESSAGE = 'Password recovery request has been successfully send. We will contact you very soon.';
  static LOGIN_ERROR_MESSAGE = 'Please enter the correct Password/Username.';
  static DEFAULT_ERROR_MESSAGE = 'Sorry, something went wrong. Please try again later.';
  static DEFAULT_SUCCESS_MESSAGE = 'Your request has been received. We will contact you shortly.';
  static AMOUNT_ERROR =
    'THE TRANSFER CAN’T BE PROCESSED DUE TO INSUFFICIENT AVAILABLE BALANCE. TOP-UP YOUR ACCOUNT AND INITIATE THE TRANSFER AGAIN OR REDUCE TRANSFER AMOUNT ACCORDINGLY.';
  static PASSWORD_ERROR_MESSAGE = 'Please enter the correct password to continue.';
  static PASSWORD_SUCCESS_MESSAGE = 'Your request has been received. You will be notified by SMS once your card has been activated.';
  static NEW_RECIPIENT_SUCCESS_MESSAGE = 'New beneficiary details have been successfully saved.';
}
